export const parserBlockName = "custom-offer-card-layout";
export const attribNames = {
    FILL_COLOR: 'data-backgroundfillcolor',
    CARD_GROUP: 'custom-offer-card-group',
    CARD_BLUSH: 'custom-card-blush-position',
    CARD_BODY: 'custom-card-body-position',
    CARD_CTA: 'custom-card-cta-position',
}
export const sourceIdSuffix = 'mktcustoffer';
export const defaultCtaUrl = "https://refinance.quickenloans.com/"
export const dataTest = {
    FOUNDATION: 'custom-offer-card-foundation'
}